/* eslint-disable no-undef */
import template from "./main-nav.html";
import { EVENT_NEW_FORM } from "constants.js";
import hotkeyConfigs from "../services/hotkeyConfig";
import * as routes from "routes.js";
import "./main-nav.less";
import headerActions from "../components/header-actions/header-actions";

export function controller(
	$rootScope, 
	$scope, 
	$element, 
	appState, 
	hotkeys, 
	$state, 
	cardSwipeService, 
	eventBus, 
	navigationService,
	$uibModal
) {
	$scope.uiState = $rootScope.uiState;
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.$onDestroy = onDestroy;
	ctrl.goTo = goTo;
	ctrl.initCardSwipe = initCardSwipe;
	ctrl.routes = routes;
	ctrl.close = close;

	function onInit() {
		updateNavigation();

		$element.on("click", e => {
			if($element[0] === e.target) {
				$scope.uiState.sidebar.open = false;
				$scope.$evalAsync();
			}
		});

		addHotKeys();

		eventBus.register(
			EVENT_NEW_FORM,
			updateNavigation,
			$scope
		);
	}

	function updateNavigation() {
		ctrl.form = appState.forms.selected;
		ctrl.navigation = navigationService.getNavigation();
	}

	function addHotKeys() {
		if(ctrl.navigation.primary.some(item => item.id === "create-report")) {
			hotkeys.add(hotkeyConfigs.GLOBAL.NEW_REPORT(`New ${ctrl.form.nomenclature.PositiveReport}`, () => {
				$state.transitionTo(routes.NEW_REPORT, { "via": "keyboard-shortcut" }, { reload: routes.NEW_REPORT });
			}));
		}

		if(ctrl.navigation.primary.some(item => item.id === "find-report")) {
			hotkeys.add(hotkeyConfigs.GLOBAL.REPORT_LIST(`Find ${ctrl.form.nomenclature.PositiveReport}`, () => {
				$state.go("authenticated.report-list", { "via": "keyboard-shortcut" });
			}));
		}

		hotkeys.add(hotkeyConfigs.GLOBAL.DASHBOARD(() => {
			$state.go("authenticated.dashboard", { "via": "keyboard-shortcut" });
		}));

		hotkeys.add(hotkeyConfigs.GLOBAL.SHOW_NAVIGATION_BAR(() => {
			$scope.uiState.sidebar.open = !$scope.uiState.sidebar.open;
		}));

		if(ctrl.navigation.primary.some(item => item.id === "compliance")) {
			hotkeys.add(hotkeyConfigs.GLOBAL.REPORT_COMPLIANCE(() => {
				$state.go("authenticated.compliance", { "via": "keyboard-shortcut" });
			}));
		}

		hotkeys.add(hotkeyConfigs.GLOBAL.QUICK_OPEN(() => {
			openQuickOpenModal();
		}));
	}

	function openQuickOpenModal() {
		$uibModal.open({
			component: "quickOpenModal",
			size: "sm"
		});
	}

	function onDestroy() {
		$element.off("click");
	}

	function goTo(route) {
		$state.transitionTo(route, { "via": "main-nav" }, { location: true, reload: route });
	}

	function initCardSwipe() {
		cardSwipeService.initializeCardSwipe();
	}

	function close() {
		$scope.uiState.sidebar.open = false;
		document.querySelector("[on-trigger-focus=main-nav]").focus();
	}
}

export default angular
	.module("vesl.layout.main-nav", [headerActions])
	.component("mainNav", { template, controller }).name;
